// extracted by mini-css-extract-plugin
module.exports = {"background":"background___24cxX"};